export enum SystemicOnboardingState {
  APPROVED = 'approved',
  DENIED = 'denied',
  AWAITING_APPROVAL = 'awaiting_approval',
}
